import { Wrapper } from '@american-autonomy/ag-ui';

import { getCalibrationKindLabels } from 'pages/MaintenancePage/components/LogServicePanel/helpers/getCalibrationKindLabels';
import { getPartLabels } from 'pages/MaintenancePage/components/ServiceIntervalConfigPanel/helpers/getPartLabels';
import { getEventTypeLabels } from 'pages/MaintenancePage/helpers/getEventTypeLabels';
import { getServiceRecordTarget } from 'pages/MaintenancePage/helpers/getServiceRecordTarget';
import { getUnitFormatters } from 'pages/MaintenancePage/helpers/getUnitFormatters';
import useTranslation from 'pages/MaintenancePage/hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

// Single caption line showing the drone's newest active service record,
// e.g. "Replaced · Motor 3 · by Dana Whitfield · 7/18/2026".
const LastServiceLine: FunctionComponent<Props> = ({
    className = '',
    record,
    testId = TEST_ID
}) => {
    const t = useTranslation();
    const eventLabels = getEventTypeLabels(t);
    const target = getServiceRecordTarget({
        calibrationKindLabels: getCalibrationKindLabels(t),
        emDash: t.EM_DASH,
        partLabels: getPartLabels(t),
        record,
        unitFormatters: getUnitFormatters(t)
    });
    const summary = t.SERVICE_RECORD_SUMMARY({ event: eventLabels[record.eventType], target });
    const attribution = t.SERVICE_RECORD_BY({
        when: new Date(record.performedAt).toLocaleDateString(),
        who: record.by
    });

    return (
        <Wrapper className={`${styles.lastServiceLine} ${className}`} testId={testId}>
            {t.LAST_SERVICE_LINE({ attribution, summary })}
        </Wrapper>
    );
};

export default LastServiceLine;
